import React, { Component, Suspense, lazy } from "react";
import { Route, Switch, BrowserRouter, withRouter } from "react-router-dom";
import { settings } from "../portfolio.js";

const Home = lazy(() => import("../pages/home/HomeComponent"));
const Splash = lazy(() => import("../pages/splash/Splash"));
const Education = lazy(() => import("../pages/education/EducationComponent"));
const Experience = lazy(() => import("../pages/experience/Experience"));
const Contact = lazy(() => import("../pages/contact/ContactComponent"));
const Projects = lazy(() => import("../pages/projects/Projects"));
const ResumePage = lazy(() => import("../pages/resume/Resume"));
const Error404 = lazy(() => import("../pages/errors/error404/Error"));

class ScrollToTopComponent extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
  }

  render() {
    return null;
  }
}

const ScrollToTop = withRouter(ScrollToTopComponent);

export default class Main extends Component {
  componentDidMount() {
    document.documentElement.style.setProperty(
      "--scrollbar-color",
      this.props.theme.imageHighlight
    );
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.theme &&
      this.props.theme &&
      prevProps.theme.imageHighlight !== this.props.theme.imageHighlight
    ) {
      document.documentElement.style.setProperty(
        "--scrollbar-color",
        this.props.theme.imageHighlight
      );
    }
  }
  render() {
    return (
      <BrowserRouter basename="/">
        <ScrollToTop />
        <Suspense
          fallback={
            <main style={{ padding: "2rem", textAlign: "center" }}>
              Loading page...
            </main>
          }
        >
          <Switch>
            <Route
              path="/"
              exact
              render={(props) =>
                settings.isSplash ? (
                  <Splash {...props} theme={this.props.theme} />
                ) : (
                  <Home {...props} theme={this.props.theme} />
                )
              }
            />
            <Route
              path="/home"
              render={(props) => <Home {...props} theme={this.props.theme} />}
            />
            <Route
              path="/experience"
              exact
              render={(props) => (
                <Experience {...props} theme={this.props.theme} />
              )}
            />
            <Route
              path="/education"
              render={(props) => (
                <Education {...props} theme={this.props.theme} />
              )}
            />

            <Route
              path="/contact"
              render={(props) => <Contact {...props} theme={this.props.theme} />}
            />

            {settings.isSplash && (
              <Route
                path="/splash"
                render={(props) => <Splash {...props} theme={this.props.theme} />}
              />
            )}

            <Route
              path="/projects"
              render={(props) => <Projects {...props} theme={this.props.theme} />}
            />
            <Route
              path="/resume"
              render={(props) => (
                <ResumePage {...props} theme={this.props.theme} />
              )}
            />
            <Route
              path="*"
              render={(props) => <Error404 {...props} theme={this.props.theme} />}
            />
          </Switch>
        </Suspense>
      </BrowserRouter>
    );
  }
}
